import styled from "styled-components";

export const ListHeaderStyles = styled.div`
  width: 100%;
  height: 97px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 ${({ theme }) => theme.spacing[24]};
  border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};

  .number {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.typography.heading.h3.size};
    line-height: ${({ theme }) => theme.typography.heading.h3.lineHeight};
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .title {
    font-style: normal;
    font-weight: 600;
    font-size: ${({ theme }) => theme.typography.body.b3.size};
    line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
    text-transform: uppercase;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
    margin-top: ${({ theme }) => theme.spacing[4]};
  }

  .viewAllContainer {
    display: flex;
    align-items: center;
    cursor: pointer;
    .viewAll {
      font-style: normal;
      font-weight: ${({ theme }) => theme.typography.body.b3.weight};
      font-size: ${({ theme }) => theme.typography.body.b3.size};
      line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
      color: ${({ theme }) => theme.colors.semantic.text.strong};
    }

    .arrowContainer {
      margin-left: ${({ theme }) => theme.spacing[12]};
      transform: rotate(-270deg);
    }
  }
`;
